/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_BodyInputs */

const en_error_body = /** @type {(inputs: Error_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your work is safe. Check the connection, then try again.`)
};

/** @type {(inputs: Error_BodyInputs) => LocalizedString} */
const ar_error_body = en_error_body;

/** @type {(inputs: Error_BodyInputs) => LocalizedString} */
const he_error_body = en_error_body;

/** @type {(inputs: Error_BodyInputs) => LocalizedString} */
const ur_error_body = en_error_body;

/** @type {(inputs: Error_BodyInputs) => LocalizedString} */
const es_error_body = en_error_body;

/** @type {(inputs: Error_BodyInputs) => LocalizedString} */
const fr_error_body = en_error_body;

/** @type {(inputs: Error_BodyInputs) => LocalizedString} */
const de_error_body = en_error_body;

/** @type {(inputs: Error_BodyInputs) => LocalizedString} */
const pt_error_body = en_error_body;

/** @type {(inputs: Error_BodyInputs) => LocalizedString} */
const hi_error_body = en_error_body;

/** @type {(inputs: Error_BodyInputs) => LocalizedString} */
const bn_error_body = en_error_body;

/**
* | output |
* | --- |
* | "Your work is safe. Check the connection, then try again." |
*
* @param {Error_BodyInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const error_body = /** @type {((inputs?: Error_BodyInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_BodyInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_error_body(inputs)
	if (locale === "he") return he_error_body(inputs)
	if (locale === "ur") return ur_error_body(inputs)
	if (locale === "es") return es_error_body(inputs)
	if (locale === "fr") return fr_error_body(inputs)
	if (locale === "de") return de_error_body(inputs)
	if (locale === "pt") return pt_error_body(inputs)
	if (locale === "hi") return hi_error_body(inputs)
	if (locale === "bn") return bn_error_body(inputs)
	return /** @type {LocalizedString} */ ("Your work is safe. Check the connection, then try again.")
});